import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function serverOfflineReducer(state = initialState.serverOffline, action) {
  switch (action.type) {
    case types.SET_SERVER_OFFLINE_SUCCESS:
      return action.serverOffline;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/serverOffline.reducer.js